/* Publish by EComposer at 2026-10-15 10:51:41*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ogfcvtafznm"]=  window.__ectimmers["ecom-ogfcvtafznm"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ogfcvtafznm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ogfcvtafznm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rw7sa9qmlqb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rw7sa9qmlqb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-og0ehbbcdrf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-og0ehbbcdrf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-70kuh5vopr9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-70kuh5vopr9', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-j26hurd9xyc"]=  window.__ectimmers["ecom-j26hurd9xyc"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-j26hurd9xyc"]["z34o63r8z"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-j26hurd9xyc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j26hurd9xyc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ht91ucmu61').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ht91ucmu61', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qsk8dehltwd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qsk8dehltwd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dwjt8xbonch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dwjt8xbonch', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tmtve7dv87i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tmtve7dv87i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gqdt88215gn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gqdt88215gn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bnuojntjk5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bnuojntjk5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mzfvzu9v9tf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mzfvzu9v9tf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ty64hlwrfmk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ty64hlwrfmk', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}